import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import styles from "./CommonInput.module.css";
import Hint from "../../Common/Hint";

/**
 * Input reutilizável que aceita diferentes tipos e configurações
 */
function CommonInput({
  label = "",
  id,
  value,
  onChange,
  type = "text",
  required = false,
  disabled = false,
  auth = false,
  inputStyle = {},
  labelStyle = {},
  hint = "",
  limit = null,
  sent = false,
  ...props
}) {
  const inputRef = useRef(null);
  const [caracteres, setCaracteres] = useState(0);
  const [color, setColor] = useState("info");
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!limit) return;
    const input = inputRef.current;
    setCaracteres(input.value.length);
  }, [limit, value]);

  useEffect(() => {
    if (!limit) return;
    const qtdCaracteres = inputRef.current.value.length;
    if (qtdCaracteres <= limit) {
      setColor("secondary");
    } else {
      setColor("danger");
    }
  }, [limit, value]);

  useEffect(() => {
    var limitError = false;
    const qtdCaracteres = inputRef.current.value.length;
    if (limit && qtdCaracteres > limit) limitError = true;
    if (sent && (limitError || !value)) setError(true);
    else setError(false);
  }, [limit, sent, value]);

  return (
    <>
      {label && (
        <>
          <label
            htmlFor={id}
            className={`${styles.label} ${auth && styles.authLabel}`}
            style={labelStyle}
          >
            {label}
          </label>
          {required && <span style={{ color: "#f46a6a" }}> *</span>}
          {hint && <Hint hint={hint} />}
        </>
      )}
      <input
        ref={inputRef}
        className={`${styles.input} ${auth && styles.authInput} ${error && styles.error}`}
        type={type}
        id={id}
        name={id}
        value={value}
        disabled={disabled}
        onChange={disabled ? null : onChange}
        required={required}
        style={inputStyle}
        {...props}
      />
      {limit && (
        <div className={styles.contador}>
          <span className={styles[color]}>
            {caracteres}/{limit}
          </span>
        </div>
      )}
    </>
  );
}

CommonInput.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  auth: PropTypes.bool,
  inputStyle: PropTypes.object,
  labelStyle: PropTypes.object,
  hint: PropTypes.string,
  limit: PropTypes.number,
  sent: PropTypes.bool,
};

export default CommonInput;
